// extracted by mini-css-extract-plugin
module.exports = {"callContainer":"widget-space--callContainer--3K3TZ"};